import { TIME_TYPES } from '@/constants/timeTypes'
import { notificationService } from '@/utils/notifications'

export const parseCoord = val => {
    const num = parseFloat(val?.toString().replace(',', '.'))
    return Number.isNaN(num) ? null : num
}

export const getRestaurantRkId = (restaurants, divisionId) =>
    restaurants.find(r => r.id === divisionId)?.rk_id || null

export const getDishType = timeType =>
    timeType === TIME_TYPES.interval ? 'cookery' : 'standard'

const formatErrorToast = error => {
    const code = error?.response?.data?.code
    const message = error?.response?.data?.error
    return code && message ? `${code} - ${message}` : 'Что-то пошло не так!'
}

export const callApi = async (dispatch, action, payload) => {
    try {
        return await dispatch(action, payload)
    } catch (error) {
        notificationService.showError(formatErrorToast(error), null)
        return null
    }
}

export const applyBaseCommits = (commit, data) => {
    commit('SET_DELIVERY_AVAILABILITY_DATA', data)
    commit('SET_IS_INTERVALS_AVAILABLE', data.is_available)
    commit('SET_INTERVALS', data.intervals || [])
}

export const canProceedWithIntervals = (
    isAvailable,
    intervals,
    isSeniorOperatorRole
) =>
    isAvailable ||
    (isSeniorOperatorRole && !isAvailable && intervals?.length > 0)
